/**
 * @generated SignedSource<<7545557858c985a1cc6524f45905fd05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OtherCostBulkUpdateInput = {
  charge: number;
  cost: number;
  date: string;
  id: number;
  name: string;
};
export type OtherCostsBulkUpdateMutation$variables = {
  input: ReadonlyArray<OtherCostBulkUpdateInput>;
  project_id: number;
  todaysDate: any;
};
export type OtherCostsBulkUpdateMutation$data = {
  readonly action_other_cost_bulk_update: {
    readonly account: {
      readonly id: number;
    } | null | undefined;
    readonly project: {
      readonly id: number;
      readonly other_costs: ReadonlyArray<{
        readonly charge: number;
        readonly cost: number;
        readonly date: string | null | undefined;
        readonly id: number;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectCostsInsight_project" | "ProjectDashboardBody_project" | "ProjectDashboardHeader_project">;
    } | null | undefined;
  } | null | undefined;
};
export type OtherCostsBulkUpdateMutation = {
  response: OtherCostsBulkUpdateMutation$data;
  variables: OtherCostsBulkUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "project_id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todaysDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "project_id",
    "variableName": "project_id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": "date",
  "args": null,
  "kind": "ScalarField",
  "name": "date_runn",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "order_by",
      "value": {
        "date": "asc"
      }
    }
  ],
  "concreteType": "other_costs",
  "kind": "LinkedField",
  "name": "other_costs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "charge",
      "storageKey": null
    }
  ],
  "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "accounts",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "project_id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstream_id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_placeholder",
  "storageKey": null
},
v16 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v17 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes_per_day",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calc_start_date",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase_id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calc_end_date",
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "assignments_aggregate_fields",
    "kind": "LinkedField",
    "name": "aggregate",
    "plural": false,
    "selections": (v20/*: any*/),
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "user_id",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v27 = {
  "alias": "isTemplate",
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v29 = [
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OtherCostsBulkUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OtherCostBulkUpdateOutput",
        "kind": "LinkedField",
        "name": "action_other_cost_bulk_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "todaysDate",
                    "variableName": "todaysDate"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "ProjectDashboardHeader_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectDashboardBody_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectCostsInsight_project"
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OtherCostsBulkUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OtherCostBulkUpdateOutput",
        "kind": "LinkedField",
        "name": "action_other_cost_bulk_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "confirmed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricing_model",
                "storageKey": null
              },
              {
                "alias": "total_budget",
                "args": null,
                "kind": "ScalarField",
                "name": "total_budget_private",
                "storageKey": null
              },
              {
                "alias": "expenses_budget",
                "args": null,
                "kind": "ScalarField",
                "name": "expenses_budget_private",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emoji",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_rates",
                "kind": "LinkedField",
                "name": "project_rates",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": "rate",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate_private",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_roles",
                "kind": "LinkedField",
                "name": "project_roles",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimated_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_members",
                "kind": "LinkedField",
                "name": "members",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "contracts",
                        "kind": "LinkedField",
                        "name": "contracts",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": "cost",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cost_private",
                            "storageKey": null
                          },
                          {
                            "alias": "padded_cost",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cost_padded_private",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "time_offs",
                        "kind": "LinkedField",
                        "name": "time_offs",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leave_type",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "first_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "last_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "just_added_timestamp",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "clients",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "website",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "milestones_aggregate",
                "kind": "LinkedField",
                "name": "milestones_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "milestones_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "phases_aggregate",
                "kind": "LinkedField",
                "name": "phases_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "phases_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "notes_aggregate",
                "kind": "LinkedField",
                "name": "notes_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "notes_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timesheet_lock_status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timesheet_locked_to",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timesheet_lock_status_updated_at",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workstreams_computed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "actuals",
                "kind": "LinkedField",
                "name": "actuals",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v22/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billable_minutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonbillable_minutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billable_note",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonbillable_note",
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "assignments",
                "kind": "LinkedField",
                "name": "assignments",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v22/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "is_billable",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "non_working_day",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "phases",
                "kind": "LinkedField",
                "name": "phases",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": "revenue_budget",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "revenue_budget_private",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "projects",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v21/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_workstreams",
                "kind": "LinkedField",
                "name": "project_workstreams",
                "plural": true,
                "selections": [
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "archivable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "actuals_aggregate",
                "kind": "LinkedField",
                "name": "actuals_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "actuals_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "assignments_aggregate",
                "kind": "LinkedField",
                "name": "assignments_aggregate",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": "future_assignments_aggregate",
                "args": [
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "_gte",
                            "variableName": "todaysDate"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "end_date_iso"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "assignments_aggregate",
                "kind": "LinkedField",
                "name": "assignments_aggregate",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_managers",
                "kind": "LinkedField",
                "name": "managers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "projects",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tags",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "references",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "client_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate_card_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "team_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_text_values",
                "kind": "LinkedField",
                "name": "custom_text_values",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  {
                    "alias": "typeId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_text_type_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_date_values",
                "kind": "LinkedField",
                "name": "custom_date_values",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  {
                    "alias": "typeId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_date_type_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_select_values",
                "kind": "LinkedField",
                "name": "custom_select_values",
                "plural": true,
                "selections": [
                  {
                    "alias": "optionId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_select_option_id",
                    "storageKey": null
                  },
                  {
                    "alias": "typeId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_select_type_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_checkbox_values",
                "kind": "LinkedField",
                "name": "custom_checkbox_values",
                "plural": true,
                "selections": [
                  {
                    "alias": "typeId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_checkbox_type_id",
                    "storageKey": null
                  },
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_links",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "href",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "show_in_planner",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "active": {
                        "_eq": true
                      }
                    }
                  }
                ],
                "concreteType": "ext_project_link",
                "kind": "LinkedField",
                "name": "ext_project_links",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_project_id",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": "external_id",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_project_id",
                    "storageKey": null
                  },
                  {
                    "alias": "external",
                    "args": null,
                    "concreteType": "ext_project",
                    "kind": "LinkedField",
                    "name": "ext_project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integration_id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ext_project_links(where:{\"active\":{\"_eq\":true}})"
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "order_by",
                    "value": {
                      "created_at": "asc"
                    }
                  }
                ],
                "concreteType": "notes",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_by",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updated_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "creator_email",
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "projects",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "notes(order_by:{\"created_at\":\"asc\"})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricing_model_readable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "other_costs_aggregate",
                "kind": "LinkedField",
                "name": "other_costs_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "other_costs_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "other_costs_sum_fields",
                        "kind": "LinkedField",
                        "name": "sum",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate_type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "rate_cards",
                "kind": "LinkedField",
                "name": "rate_card",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "milestones",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v28/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget_method",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "teams",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99dec1bf31fb7fbe1ad01617c7ff32a6",
    "id": null,
    "metadata": {},
    "name": "OtherCostsBulkUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OtherCostsBulkUpdateMutation(\n  $input: [OtherCostBulkUpdateInput!]!\n  $project_id: Int!\n  $todaysDate: date!\n) {\n  action_other_cost_bulk_update(input: $input, project_id: $project_id) {\n    project {\n      id\n      other_costs(order_by: {date: asc}) {\n        id\n        name\n        date: date_runn\n        cost\n        charge\n      }\n      ...ProjectDashboardHeader_project_1veEkR\n      ...ProjectDashboardBody_project\n      ...ProjectCostsInsight_project\n    }\n    account {\n      id\n    }\n  }\n}\n\nfragment CreateTemplateFromProjectForm_project on projects {\n  id\n  name\n  tags\n  workstreams_computed\n  active\n  pricing_model\n  client_id\n  rate_card_id\n  team_id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  ...ProjectCustomEditor_project\n}\n\nfragment EditProjectForm_project on projects {\n  id\n  name\n  managers {\n    id\n    user_id\n    project {\n      id\n    }\n  }\n  tags\n  workstreams_computed\n  confirmed\n  active\n  pricing_model\n  references\n  client_id\n  rate_card_id\n  team_id\n  is_template\n  emoji\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  members {\n    id\n    project_id\n    workstream_id\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  ...ProjectCustomEditor_project\n  ...ExtLinks_Project\n}\n\nfragment ExtLinks_Project on projects {\n  ext_project_links(where: {active: {_eq: true}}) {\n    project_id\n    ext_project_id\n    active\n    external_id: ext_project_id\n    external: ext_project {\n      id\n      __typename\n      name\n      remote_url\n      remote_id\n      integration_id\n    }\n  }\n}\n\nfragment FindAndSelectPeople_project on projects {\n  id\n  is_template\n  project_workstreams {\n    workstream_id\n  }\n}\n\nfragment PersonRow_project on projects {\n  id\n  name\n  members {\n    id\n    project_id\n    person_id\n    role_id\n  }\n  ...RemoveMembershipFromProjectMenuItem_project\n}\n\nfragment PhasesTable_project on projects {\n  id\n  pricing_model\n  budget_method\n  is_template\n  calc_start_date\n  total_budget: total_budget_private\n  actuals {\n    id\n    project_id\n    person_id\n    phase_id\n    role_id\n    workstream_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n  }\n  assignments {\n    id\n    phase_id\n    project_id\n    person_id\n    role_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    non_working_day\n  }\n  phases {\n    id\n    name\n    color\n    start_date: start_date_runn\n    end_date: end_date_runn\n    revenue_budget: revenue_budget_private\n    project_id\n    project {\n      id\n      calc_start_date\n      calc_end_date\n    }\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    date: date_runn\n    charge\n    cost\n  }\n  members {\n    id\n    person {\n      id\n      first_name\n      last_name\n      email\n      image_key\n      is_placeholder\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        padded_cost: cost_padded_private\n      }\n      time_offs {\n        id\n        leave_type\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n      }\n    }\n  }\n}\n\nfragment ProjectActuals_project on projects {\n  id\n  name\n  is_template\n  pricing_model\n  timesheet_lock_status\n  timesheet_locked_to\n  timesheet_lock_status_updated_at\n  calc_start_date\n  workstreams_computed\n  project_rates {\n    id\n    rate: rate_private\n    role_id\n  }\n  client {\n    id\n    internal\n  }\n  actuals {\n    id\n    project_id\n    person_id\n    role_id\n    phase_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n    billable_note\n    nonbillable_note\n    workstream_id\n  }\n  assignments {\n    id\n    project_id\n    person_id\n    role_id\n    phase_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    workstream_id\n    non_working_day\n    person {\n      id\n      is_placeholder\n    }\n  }\n  phases {\n    id\n    name\n    color\n    start_date: start_date_runn\n    end_date: end_date_runn\n  }\n  members {\n    id\n    person_id\n    project_id\n    role_id\n    workstream_id\n    is_placeholder\n  }\n  ...FindAndSelectPeople_project\n}\n\nfragment ProjectBudgetFinancialInsight_project on projects {\n  total_budget: total_budget_private\n}\n\nfragment ProjectBudgetRemainingFinancialInsight_project on projects {\n  pricing_model\n  total_budget: total_budget_private\n  other_costs(order_by: {date: asc}) {\n    id\n    charge\n  }\n}\n\nfragment ProjectBudgetTimeInsight_project on projects {\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n}\n\nfragment ProjectBudgetTimeRemainingInsight_project on projects {\n  pricing_model\n  client {\n    internal\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n}\n\nfragment ProjectCompletedActuals_project on projects {\n  id\n  confirmed\n  timesheet_lock_status\n  timesheet_locked_to\n  timesheet_lock_status_updated_at\n  actuals {\n    id\n    project_id\n    person_id\n    role_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n    phase_id\n    workstream_id\n  }\n  assignments {\n    id\n    project_id\n    person_id\n    role_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    non_working_day\n    phase_id\n    workstream_id\n  }\n  members {\n    id\n    person {\n      id\n      is_placeholder\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        padded_cost: cost_padded_private\n      }\n      time_offs {\n        id\n        leave_type\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n      }\n    }\n  }\n  ...ProjectActuals_project\n}\n\nfragment ProjectCompletedTimeInsight_project on projects {\n  pricing_model\n  client {\n    internal\n  }\n}\n\nfragment ProjectCostsFinancialInsight_project on projects {\n  pricing_model\n  client {\n    internal\n  }\n  other_costs(order_by: {date: asc}) {\n    cost\n  }\n}\n\nfragment ProjectCostsInsight_project on projects {\n  other_costs_aggregate {\n    aggregate {\n      sum {\n        cost\n      }\n    }\n  }\n}\n\nfragment ProjectCustomEditor_project on projects {\n  id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n}\n\nfragment ProjectDashboardBody_project on projects {\n  id\n  ...ProjectCompletedActuals_project\n  ...ProjectInsights_project\n  ...ProjectPerformance_project\n  ...VarianceReport_project\n  ...ProjectMembers_project\n  ...ProjectMilestonesCard_project\n  ...PhasesTable_project\n  ...ProjectDashboardDetails_project\n}\n\nfragment ProjectDashboardDetails_project on projects {\n  id\n  name\n  confirmed\n  pricing_model_readable\n  tags\n  references\n  calc_start_date\n  calc_end_date\n  team {\n    id\n    name\n  }\n  links {\n    id\n    href\n    name\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  ...EditProjectForm_project\n  ...ExtLinks_Project\n}\n\nfragment ProjectDashboardDropdown_project_1veEkR on projects {\n  id\n  name\n  confirmed\n  active\n  archivable\n  calc_start_date\n  client {\n    id\n    name\n    active\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  future_assignments_aggregate: assignments_aggregate(where: {end_date_iso: {_gte: $todaysDate}}) {\n    aggregate {\n      count\n    }\n  }\n  ...EditProjectForm_project\n  ...CreateTemplateFromProjectForm_project\n}\n\nfragment ProjectDashboardHeader_project_1veEkR on projects {\n  id\n  name\n  active\n  confirmed\n  pricing_model\n  total_budget: total_budget_private\n  expenses_budget: expenses_budget_private\n  emoji\n  is_template\n  project_rates {\n    id\n    project_id\n    role_id\n    rate: rate_private\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  members {\n    id\n    role_id\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    name\n    date: date_runn\n    cost\n    charge\n  }\n  client {\n    id\n    name\n    internal\n    website\n    image_key\n  }\n  milestones_aggregate {\n    aggregate {\n      count\n    }\n  }\n  phases_aggregate {\n    aggregate {\n      count\n    }\n  }\n  notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...ProjectHistoryDialog_project\n  ...ProjectActuals_project\n  ...ProjectDashboardDropdown_project_1veEkR\n  ...ViewExternalProjectLink_project\n  ...ProjectSidePanel_project\n}\n\nfragment ProjectFinancialInsights_project on projects {\n  is_template\n  pricing_model\n  ...ProjectBudgetFinancialInsight_project\n  ...ProjectBudgetRemainingFinancialInsight_project\n  ...ProjectCostsFinancialInsight_project\n  ...ProjectGrossProfitFinancialInsight_project\n  ...ProjectMarginFinancialInsight_project\n  ...ProjectRevenueFinancialInsight_project\n  ...ProjectTMBenchmarkFinancialInsight_project\n  ...UnallocatedBudgetInsight_project\n}\n\nfragment ProjectGrossProfitFinancialInsight_project on projects {\n  pricing_model\n  total_budget: total_budget_private\n  client {\n    internal\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    charge\n    cost\n  }\n  project_rates {\n    id\n  }\n}\n\nfragment ProjectHistoryDialog_project on projects {\n  id\n}\n\nfragment ProjectInsights_project on projects {\n  pricing_model\n  pricing_model_readable\n  project_rates {\n    rate: rate_private\n    id\n    role_id\n  }\n  client {\n    internal\n  }\n  assignments {\n    id\n    person_id\n    project_id\n    role_id\n    phase_id\n    workstream_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    non_working_day\n  }\n  actuals {\n    id\n    person_id\n    project_id\n    role_id\n    phase_id\n    workstream_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n  }\n  members {\n    id\n    person {\n      id\n      is_placeholder\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        padded_cost: cost_padded_private\n      }\n      time_offs {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        leave_type\n      }\n    }\n  }\n  ...ProjectTimeInsights_project\n  ...ProjectFinancialInsights_project\n}\n\nfragment ProjectLengthInsight_project on projects {\n  calc_start_date\n  calc_end_date\n}\n\nfragment ProjectMarginFinancialInsight_project on projects {\n  pricing_model\n  total_budget: total_budget_private\n  client {\n    internal\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    charge\n    cost\n  }\n  project_rates {\n    id\n  }\n}\n\nfragment ProjectMembers_project on projects {\n  id\n  name\n  total_budget: total_budget_private\n  expenses_budget: expenses_budget_private\n  pricing_model\n  rate_type\n  active\n  confirmed\n  references\n  is_template\n  calc_start_date\n  actuals {\n    id\n    project_id\n    person_id\n    role_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n    phase_id\n    workstream_id\n  }\n  assignments {\n    id\n    project_id\n    person_id\n    role_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    non_working_day\n    phase_id\n    is_template\n    workstream_id\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  members {\n    id\n    person_id\n    role_id\n    workstream_id\n    person {\n      id\n      first_name\n      last_name\n      email\n      image_key\n      is_placeholder\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        padded_cost: cost_padded_private\n      }\n      time_offs {\n        id\n        leave_type\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n      }\n    }\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    name\n    date: date_runn\n    charge\n    cost\n  }\n  rate_card {\n    id\n    name\n  }\n  client {\n    id\n    internal\n  }\n  ...PersonRow_project\n}\n\nfragment ProjectMilestonesCard_project on projects {\n  id\n  name\n  is_template\n  calc_start_date\n  milestones {\n    id\n    title\n    icon\n    date: date_runn\n    note\n    project_id\n  }\n}\n\nfragment ProjectNote_note on notes {\n  id\n  note\n  created_by\n  created_at\n  updated_at\n  creator_email\n  user_id\n  project {\n    id\n    isTemplate: is_template\n  }\n}\n\nfragment ProjectPerformance_project on projects {\n  id\n  name\n  total_budget: total_budget_private\n  expenses_budget: expenses_budget_private\n  pricing_model\n  rate_type\n  active\n  confirmed\n  references\n  is_template\n  calc_start_date\n  calc_end_date\n  actuals {\n    id\n    project_id\n    person_id\n    role_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n    phase_id\n    workstream_id\n  }\n  assignments {\n    id\n    project_id\n    person_id\n    role_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    non_working_day\n    phase_id\n    workstream_id\n    is_template\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    date: date_runn\n    charge\n    cost\n  }\n  rate_card {\n    id\n    name\n  }\n  client {\n    id\n    internal\n  }\n  members {\n    id\n    person {\n      id\n      first_name\n      last_name\n      email\n      image_key\n      is_placeholder\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        padded_cost: cost_padded_private\n      }\n      time_offs {\n        id\n        leave_type\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n      }\n    }\n  }\n}\n\nfragment ProjectRevenueFinancialInsight_project on projects {\n  pricing_model\n  total_budget: total_budget_private\n  project_rates {\n    id\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    charge\n  }\n}\n\nfragment ProjectSidePanelNotes_project on projects {\n  id\n  isTemplate: is_template\n  notes(order_by: {created_at: asc}) {\n    id\n    note\n    created_at\n    ...ProjectNote_note\n  }\n}\n\nfragment ProjectSidePanel_project on projects {\n  id\n  name\n  emoji\n  client {\n    image_key\n    website\n    name\n  }\n  notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...ProjectSidePanelNotes_project\n}\n\nfragment ProjectTMBenchmarkFinancialInsight_project on projects {\n  pricing_model\n  client {\n    internal\n  }\n  other_costs(order_by: {date: asc}) {\n    charge\n  }\n  total_budget: total_budget_private\n}\n\nfragment ProjectTimeInsights_project on projects {\n  total_budget: total_budget_private\n  pricing_model\n  is_template\n  client {\n    internal\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  other_costs(order_by: {date: asc}) {\n    charge\n    cost\n  }\n  ...ProjectBudgetTimeInsight_project\n  ...ProjectBudgetTimeRemainingInsight_project\n  ...ProjectCompletedTimeInsight_project\n  ...ProjectCostsInsight_project\n  ...ProjectTotalTimeInsight_project\n  ...ProjectLengthInsight_project\n}\n\nfragment ProjectTotalTimeInsight_project on projects {\n  pricing_model\n  is_template\n  client {\n    internal\n  }\n}\n\nfragment RemoveMembershipFromProjectMenuItem_project on projects {\n  id\n  name\n  members {\n    id\n    project_id\n    person_id\n    workstream_id\n    role_id\n  }\n}\n\nfragment UnallocatedBudgetInsight_project on projects {\n  pricing_model\n  client {\n    internal\n  }\n  total_budget: total_budget_private\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  members {\n    id\n    role_id\n  }\n  expenses_budget: expenses_budget_private\n  other_costs(order_by: {date: asc}) {\n    charge\n    cost\n    date: date_runn\n    id\n  }\n  project_rates {\n    id\n    project_id\n    role_id\n    rate: rate_private\n  }\n}\n\nfragment VarianceReport_project on projects {\n  id\n  name\n  total_budget: total_budget_private\n  pricing_model\n  confirmed\n  actuals {\n    id\n    project_id\n    person_id\n    role_id\n    date: date_runn\n    billable_minutes\n    nonbillable_minutes\n    phase_id\n    workstream_id\n  }\n  assignments {\n    id\n    project_id\n    person_id\n    role_id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    minutes_per_day\n    is_billable\n    non_working_day\n    phase_id\n    workstream_id\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    charge\n  }\n  members {\n    id\n    workstream_id\n    person {\n      id\n      email\n      image_key\n      first_name\n      last_name\n      is_placeholder\n      contracts {\n        id\n        padded_cost: cost_padded_private\n        start_date: start_date_runn\n        end_date: end_date_runn\n      }\n      time_offs {\n        id\n        leave_type\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n      }\n    }\n  }\n}\n\nfragment ViewExternalProjectLink_project on projects {\n  id\n  ...ExtLinks_Project\n}\n"
  }
};
})();

(node as any).hash = "e1a4c57fb67c2c27f67882d4c719fc2d";

export default node;
